import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addSalonProfile = catchAsync(async (body) => {
  // const data = await axiosInstance.post(`salon/salon-profiles`, body, {
  //   headers: {
  //     "Content-Type": "multipart/form-data",
  //   },
  // });
  const data = await axiosInstance({
    url: "salon/salon-profiles",
    data: body,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
});
export const getTeamSize = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/team-sizes");
  return data;
});
export const getServices = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/on-boarding-services");
  return data;
});
export const getSubscriptionPlans = catchAsync(async () => {
  const { data } = await axiosInstance.get("salon/subscription-plans");
  return data;
});
